import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Button,
  FullScreenLoading,
  TextInput,
  TimePicker,
} from "src/Components";
import { IAdaptationManagementConfig } from "src/Interfaces/collateral";
import {
  getAdaptationSetting,
  setAdaptationSetting,
} from "src/Requests/collateral";
import { packetErrorHandler } from "src/Utils/requestUtils";

interface IProps {
  onClose: () => void;
}

const ConfigModalUI = ({ onClose }: IProps) => {
  const [config, setConfig] = useState({} as IAdaptationManagementConfig);

  const [loading, setLoading] = useState(false);

  const convertTimeToISO = (time: string) => {
    const date = new Date();
    const [hours, minutes, seconds] = time.split(":");
    date.setHours(parseInt(hours), parseInt(minutes), parseInt(seconds));

    // Convert to ISO string
    const isoString = date.toISOString();
    return isoString;
  };

  useEffect(() => {
    setLoading(true);
    getAdaptationSetting()
      .then((resp) => {
        setConfig({
          ...resp,
          closeDayTimeISO: convertTimeToISO(resp.closeDayTime),
          middleDayStartISO: convertTimeToISO(resp.middleDayStart),
        });
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }, []);

  const changeHandler = (name: string, value: any) => {
    if (name === "middleDayStart" || name === "closeDayTime")
      setConfig({
        ...config,
        [name]: value.timeString,
        [name + "ISO"]: value.ISOString,
      });
    else setConfig({ ...config, [name]: value });
  };

  const submitHandler = () => {
    setLoading(true);
    setAdaptationSetting(config)
      .then((resp) => {
        if (!resp.data) toast.error(resp.msg);
        else {
          toast.success(resp.msg);
          onClose();
        }
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <div className="flex flex-col justify-start items-start gap-3">
      {loading ? <FullScreenLoading /> : <></>}
      <TimePicker
        onChange={changeHandler}
        placeholder="ساعت شروع تطبیق میان روز"
        value={config.middleDayStartISO}
        name="middleDayStart"
        extraLabel
      />
      <TextInput
        extraLabel
        onChange={changeHandler}
        label="فواصل زمانی تطبیق میان روز(دقیقه)"
        value={config.middleDayInterval?.toString()}
        name="middleDayInterval"
      />
      <TimePicker
        onChange={changeHandler}
        placeholder="ساعت تطبیق پایان روز"
        value={config.closeDayTimeISO}
        name="closeDayTime"
        extraLabel
      />
      <TextInput
        kind="percent"
        extraLabel
        onChange={changeHandler}
        label="% تلورانس مجاز مازاد وثیقه"
        value={config.telorance?.toString()}
        name="telorance"
      />
      <TextInput
        kind="percent"
        extraLabel
        onChange={changeHandler}
        label="% حداقل وجه اختیار به کل"
        value={config.minMarginTotalRatio?.toString()}
        name="minMarginTotalRatio"
      />
      <Button text="ثبت" variant="contained" onClick={submitHandler} />
    </div>
  );
};

export default ConfigModalUI;
